<template>
  <div class="glass transition duration-700 transform rounded-lg hover:shadow-md hover:scale-105" style="overflow: hidden">
    <!-- 作品展示卡片 -->
    <div @click="handleOpen" class="flex flex-col items-start w-full cursor-pointer">
      <div class="flex flex-col w-full">
        <el-image class="w-full transition duration-700 transform rounded-t-lg h-44 lg:h-40 hover:scale-110" :src="props.url" fit="cover" lazy>
          <template #error>
            <div class="flex items-center justify-center w-full h-full bg-gray-200">
              <el-icon><icon-picture /></el-icon>
            </div>
          </template>
        </el-image>
      </div>

      <div class="w-full">
        <div class="h-16 lg:h-20">
          <span class="p-2 text-xs font-bold lg:text-sm text-wrap line-clamp-2">
            {{ props.projectName }}
          </span>

          <!-- 课程介绍 -->
          <span class="pl-2 pr-2 text-xs text-wrap text-slate-500 line-clamp-2">
            {{ props.work_introduce }}
          </span>
        </div>

        <div class="flex flex-row items-center w-full p-2 pb-2">
          <div class="flex flex-col items-center space-x-2 md:flex-row md:text-xs">
            <!-- <TagVueVue class=" lg:scale-100 md:scale-75" bg-color="#F1F1F3">{{ checkGrade(props.grade ?? 1) }}</TagVueVue> -->

            <el-tag class="lg:scale-100 md:scale-75" :type="contestCheck(props.projectType ?? 0)" size="small" effect="plain">{{ checkContestName(props.projectType ?? 0) }}</el-tag>
            <p class="flex ml-auto text-xs text-gray-400 line-clamp-1 lg:scale-100 md:scale-75">{{ props.work_watch_count ?? 0 }}次观看</p>
          </div>
          <div class="flex justify-end ml-auto">
            <p class="flex ml-auto text-xs text-gray-400 line-clamp-1 lg:scale-100 md:scale-75">
              {{ user_school }}
            </p>
            <div v-if="work_status === 1">
              <SupperTagVue></SupperTagVue>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import { Picture as IconPicture } from '@element-plus/icons-vue'
import { userLogin } from '~/stores/userLogin'
import { useWorkListCreateTime } from '~/stores/workList/workListCreatTime'
import { checkContestName, contestCheck } from '~/composables/workList/workListCard'
import SupperTagVue from './SupperTag.vue'

const emit = defineEmits<{
  (e: 'open', payload: { id: number }): void
}>()

const props = defineProps({
  //  作品 id
  id: {
    type: Number,
  },
  //图片链接
  url: {
    type: String,
  },
  //作品名称
  projectName: {
    type: String,
    default: '作品名称',
  },
  //作者年级
  grade: {
    type: Number,
  },
  //作品赛道
  projectType: {
    type: Number,
  },
  work_introduce: {
    type: String,
  },
  work_watch_count: {
    type: Number,
  },
  createTime: {
    type: String,
  },
  user_school: {
    type: String,
    default: '',
  },
  work_status: {
    type: Number,
    default: 0,
  },
  showWorkStatus: {
    type: Boolean,
    default: false,
  },
  openMode: {
    type: String as PropType<'route' | 'modal'>,
    default: 'route',
  },
})

const loginStore = userLogin()
const projectCreateTime = useWorkListCreateTime()

onMounted(async () => {
  await nextTick()
  if (props.createTime) {
    projectCreateTime.updateCreateTime(props.createTime)
  }
})

// 状态判断(0 待审核 1 审核通过 )
const checkWorkStatus = (status: number): string => {
  switch (status) {
    case 0:
      return 'info'
    case 1:
      return 'danger'
  }
  return 'info'
}

//显示年级
const checkGrade = (grade: number): string => {
  switch (grade) {
    case 1:
      return '初一'
    case 2:
      return '二年级'
    case 3:
      return '三年级'
    case 4:
      return '四年级'
    case 5:
      return '五年级'
    case 6:
      return '六年级'
    case 7:
      return '初一'
    case 8:
      return '初二'
    case 9:
      return '初三'
  }
  return '年级无效'
}

const router = useRouter()
const handleOpen = () => {
  if (loginStore.isLogin) {
    if (!props.id) {
      return
    }
    if (props.openMode === 'modal') {
      emit('open', { id: props.id })
      return
    }
    router.push({ path: '/galleryDetail', query: { id: props.id } })
  } else {
    ElMessage({
      message: '登录信息过期，请重新登录',
      type: 'error',
    })
  }
}
</script>

<style></style>
